import { Component, inject } from '@angular/core';
import {
  NOTICE_FORM_NAME,
  SUMMARY_FORM_NAME,
} from 'src/app/services/form/form.factory';
import { NoticeForm, SummaryForm } from 'src/app/services/form/form.controls';
import { FormService } from 'src/app/services/form/form.service';
import { PayeeFormFieldComponent } from '../../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notice-form',
  templateUrl: './notice-form.component.html',
  styleUrls: ['./notice-form.component.scss'],
  imports: [
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class NoticeFormComponent {
  private formService = inject(FormService);

  private get form(): SummaryForm {
    return this.formService.form.controls[SUMMARY_FORM_NAME]!;
  }
  get noticeForm(): NoticeForm {
    return this.form.controls[NOTICE_FORM_NAME]!;
  }
  get email() {
    return this.noticeForm.controls.email;
  }
}
